import React from "react";
import { useParams } from "react-router-dom";

const CONTENT = {
  envio: {
    title: "Política de Envio",
    body: [
      "A VOLTIX entrega em Portugal 🇵🇹 e Angola 🇦🇴.",
      "Portugal: envio standard em 1-3 dias úteis (€4,99).",
      "Angola: envio standard em 7-14 dias úteis (€24,99).",
      "Encomendas acima de €200 têm portes grátis.",
      "O acompanhamento é enviado por email assim que a encomenda sai do armazém.",
    ],
  },
  devolucao: {
    title: "Política de Devolução",
    body: [
      "Podes devolver qualquer produto em bom estado nos 30 dias após a receção.",
      "Os produtos devem estar na embalagem original com todos os acessórios.",
      "Reembolsos são processados em 5-10 dias úteis através do método de pagamento original.",
      "Contacta support@voltix.com para iniciar uma devolução.",
    ],
  },
  privacidade: {
    title: "Política de Privacidade",
    body: [
      "A VOLTIX respeita a tua privacidade e cumpre o RGPD.",
      "Recolhemos apenas os dados necessários para processar as tuas encomendas e melhorar a experiência.",
      "Nunca vendemos os teus dados a terceiros.",
      "Podes solicitar acesso, correção ou eliminação dos teus dados a qualquer momento.",
    ],
  },
  termos: {
    title: "Termos e Condições",
    body: [
      "Ao utilizar o site voltix.com aceitas os presentes termos.",
      "Os preços podem variar consoante o país e a moeda selecionada.",
      "A VOLTIX reserva-se o direito de alterar preços, promoções e disponibilidade sem aviso prévio.",
      "Todos os produtos vêm com garantia mínima de 24 meses.",
    ],
  },
  sobre: {
    title: "Sobre a VOLTIX",
    body: [
      "A VOLTIX nasceu para levar tecnologia de qualidade a Portugal e Angola.",
      "Trabalhamos com marcas selecionadas e produtos originais com garantia.",
      "Sediados em Portugal, com armazém e apoio dedicado para clientes angolanos.",
      "A nossa missão: tecnologia ao teu alcance.",
    ],
  },
  novidades: {
    title: "Novidades",
    body: ["Descobre os lançamentos mais recentes da VOLTIX.", "Consulta a página de produtos filtrando por 'Novos'."],
  },
  promocoes: {
    title: "Promoções",
    body: ["Aproveita códigos como VOLTIX10 (-10%) e WELCOME20 (-20% em compras acima de €200)."],
  },
  categorias: {
    title: "Categorias",
    body: ["Explora as nossas categorias na página inicial ou em Produtos."],
  },
};

export default function Policies() {
  const { slug } = useParams();
  const c = CONTENT[slug] || { title: "Página", body: ["Conteúdo em breve."] };
  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <h1 className="text-4xl font-display font-bold mb-6">{c.title}</h1>
      <div className="space-y-4 text-muted-foreground leading-relaxed">
        {c.body.map((p, i) => <p key={i}>{p}</p>)}
      </div>
    </div>
  );
}
